import Vue from "vue";
import Router from "vue-router";
//import AdminRoutes from './routes/admin-routes';
//import { Role } from '@/core/helpers/rol';

Vue.use(Router);

const router = new Router({
  routes: [
    
    {
      path: "/",
      name: 'root',
      redirect: "/dashboard",
      component: () => import("@/view/layout/Layout"),

      
      children: [
        {
          path: "/dashboard",
          name: "dashboard",
          component: () => import("@/view/pages/Dashboard.vue"),
          meta: { authorize: [1,2,3,4,5,6] } 
        },
        {
          path: "/dashboard-informador",
          name: "dashboard-informador",
          component: () => import("@/view/pages/dashboards/DashboardInformador.vue"),
          // meta: { authorize: [4] } 
        },
        {
          path: "/dashboard-master-instituciones",
          name: "dashboard-master-instituciones",
          component: () => import("@/view/pages/dashboards/DashboardMasterInstituciones.vue"),
          meta: { authorize: [1] } 
        },
        {
          path: "/dashboard-revisor-aprobador",
          name: "dashboard-revisor-aprobador",
          component: () => import("@/view/pages/dashboards/DashboardRevisorAprobador.vue"),
          meta: { authorize: [2,3] } 
          //meta: { authorize: [100] },
        },
        {
          path: "/dashboard-creador",
          name: "dashboard-creador",
          component: () => import("@/view/pages/dashboards/DashboardCreador.vue"),
          meta: { authorize: [5] } 
        },
        {
          name: "mi-perfil",
          path: "/configuracion/cuenta",
          component: () => import("@/view/pages/perfil/PaginaPerfilUsuario.vue"),
          meta: { authorize: [1,2,3,4,5,6] } 
        },

        //!Rutas para la recoleccion de datos de las municipalidades
        {
          path: "/municipalidades",
          name: "admin-munis",
          component: () => import("@/view/pages/admin/Dashboard.vue"),
          
        
          children: [
            {
              path: "boletas/responder",
              name: "boletas-responder",
              component: () => import("@/view/pages/recolector/boletas/PaginaRespuestasBoleta.vue"),
              meta: { authorize: [4] }
            },
            {
              path: "boletas/responder/:boletaMuniId/:idBoleta/:idPeriodo",
              name: "boletas-responder-especifica",
              component: () => import("@/view/pages/recolector/boletas/PaginaRespuestasBoleta.vue"),
              meta: { authorize: [4] }
            }
          ]
        },


        //!Rutas para la revisión de respuestas 
        {
          path: "/revision",
          name: "revision-seleccion",
          component: () => import("@/view/pages/admin/Dashboard.vue"),
        
          children: [
            {
              path: "municipalidad/seleccionar",
              name: "revision-municipalidades-asignar",
              component: () => import("@/view/pages/revision/PaginaSeleccionMuniPeriodoRevision.vue"),
              meta: { authorize: [2,3] },
              //meta: { authorize: [100] },
            },
            {
              path: "municipalidad/seleccionar/preguntas/:municipalidadId/:periodoId",
              name: "revision-municipalidades-preguntas",
              component: () => import("@/view/pages/revision/PaginaAdminSeleccionPreguntasMuni.vue"),
              meta: { authorize: [2,3] },
             // meta: { authorize: [100] },
            },
          ]
        },


         //!Rutas para la aprobacion de respuestas 
         {
          path: "/aprobacion",
          name: "aprobacion-seleccion",
          component: () => import("@/view/pages/admin/Dashboard.vue"),
        
          children: [
            {
              path: "municipalidad/seleccionar",
              name: "aprobacion-municipalidades-asignar",
              component: () => import("@/view/pages/aprobacion/PaginaSeleccionMuniPeriodoAprobacion.vue"),
              meta: { authorize: [2,3] },
              //meta: { authorize: [100] },
            },
            {
              path: "municipalidad/preguntas/aprobacion/:municipalidadId/:periodoId",
              name: "aprobacion-municipalidades-preguntas",
              component: () => import("@/view/pages/aprobacion/PaginaAdminAprobacionRespuestas.vue"),
              meta: { authorize: [2,3] },
              //meta: { authorize: [100] },
            },
          ]
        },



        



        //!Rutas administración
        {
          path: "/admin",
          name: "admin",
          component: () => import("@/view/pages/admin/Dashboard.vue"),
          
  
          children: [
              { 
                path: 'catalogos',
                name: 'catalogos',
                component: () => import("@/view/pages/admin/Dashboard.vue"),
                meta: { authorize: [6] },

                children: [
                  {
                    path: "periodos",
                    name: "perioods",
                    component: () => import("@/view/pages/admin/catalogos/periodosmedicion/PaginaAdminPeriodos.vue")
                  },
                  {
                    path: "indices",
                    name: "indices",
                    component: () => import("@/view/pages/admin/catalogos/indices/PaginaAdminIndices.vue"),
                    meta: { authorize: [6] },
                  },
                  {
                    path: "listas",
                    name: "listas",
                    component: () => import("@/view/pages/admin/catalogos/listas/PaginaAdminListas.vue"),
                    meta: { authorize: [6] },
                  },
                  {
                    path: "mediosverificacion",
                    name: "mediosverificacion",
                    component: () => import("@/view/pages/admin/catalogos/mediosverificacion/PaginaAdminMediosVerificacion.vue"),
                    meta: { authorize: [6] },
                  },

                  {
                    path: "roles",
                    name: "roles",
                    component: () => import("@/view/pages/admin/catalogos/roles/PaginaAdminRoles.vue"),
                    meta: { authorize: [6] },
                  }

                ]
              },
              {
                path: 'usuarios',
                name: 'usuarios',
                component: () => import("@/view/pages/admin/Dashboard.vue"),
                children: [
                  {
                    path: "creadores-departamentales",
                    name: "creadores-departamentales",
                    component: () => import("@/view/pages/admin/usuarios/creadoresdepartamentales/PaginaAdminCreadoresDepartamentales.vue"),
                    meta: { authorize: [6] },
                  },

                  {
                    path: "administradores",
                    name: "usuarios-administradores",
                    component: () => import("@/view/pages/admin/usuarios/administradores/PaginaAdminAdministradores.vue"),
                    meta: { authorize: [6] },
                  }
                ]
              },
              
              /*{
                path: "/catalogos",
                name: "catalogos",
                component: () => import("@/view/pages/admin/Dashboard.vue"),

                children:[
                  
                ]

              },*/
              {
                path: "crud",
                name: "crud-example",
                component: () => import("@/view/pages/admin/crud/CrudExample.vue")
              },
              {
                path: "instituciones",
                name: "instituciones",
                component: () => import("@/view/pages/admin/instituciones/PaginaAdminInstituciones.vue")
              },
              {
                path: "institucion/usuarios",
                name: "institucion-usuarios",
                //component: () => import("@/view/pages/admin/instituciones/usuarios/PaginaAdminUsuariosInstitucion.vue"),
                component: () => import("@/view/pages/admin/Dashboard.vue"),
                children: [
                  {
                    path: "registro",
                    name: "registro-usuarios-institucion",
                    component: () => import("@/view/pages/admin/instituciones/usuarios/PaginaAdminUsuariosInstitucion.vue"),
                    meta: { authorize: [1,6] },
                  },
                  //!Asingancion de Revisores y Arpobadores a municipalidades por periodo
                  {
                    path: "asignacion-muni-periodo",
                    name: "asignacion-usuarios-institucion-muni",
                    component: () => import("@/view/pages/admin/instituciones/usuarios/usuariosmunicipalidad/PaginaAsignacionAprobadoresRevisoresMunicipalidad.vue"),
                    meta: { authorize: [1,6] },
                  },
                ]

              },
              

              //!Usuarios tipo informadores municipales
              {
                path: "informadores-municipales",
                name: "usuarios-informadores-municipales",
                component: () => import("@/view/pages/admin/informadoresmunicipales/PaginaAdminInformadoresMunicipales.vue"),
                meta: { authorize: [5,6] },
              },

               //!Asingancion de informadores municipales
               {
                path: "informadores-municipales/asingacion-muni",
                name: "informadores-muni",
                component: () => import("@/view/pages/admin/instituciones/usuarios/usuariosmunicipalidad/PaginaAsignacionInformadoresMunicipalidad.vue"),
                meta: { authorize: [5,6] },
              },
              
              {
                path: "compliant",
                name: "main-complaint",
                component: () => import("@/view/pages/admin/compliant/PaginaAdminBandejaCompliant.vue")
              },

              {
                path: "puestos",
                name: "puestos",
                component: () => import("@/view/pages/admin/catalogos/puestos/PaginaAdminPuestos.vue"),
                meta: { authorize: [6] },
              },

              {
                path: "regiones",
                name: "regiones",
                component: () => import("@/view/pages/admin/catalogos/regiones/PaginaAdminRegiones.vue"),
                meta: { authorize: [6] },
              },

              {
                path: "departamentos",
                name: "departamentos",
                component: () => import("@/view/pages/admin/catalogos/departamentos/PaginaAdminDepartamentos.vue"),
                meta: { authorize: [6] },
              },

              {
                path: "municipios",
                name: "municipios",
                component: () => import("@/view/pages/admin/catalogos/municipios/PaginaAdminMunicipios.vue"),
                meta: { authorize: [6] },
              },

              {
                path: "tiposSocio",
                name: "tiposSocio",
                component: () => import("@/view/pages/admin/catalogos/tiposSocio/PaginaAdminTiposSocio.vue"),
                meta: { authorize: [6] },
              },

              {
                path: "tiposEmpresa",
                name: "tiposEmpresa",
                component: () => import("@/view/pages/admin/catalogos/tiposEmpresa/PaginaAdminTiposEmpresa.vue"),
                meta: { authorize: [6] },
              },

              {
                path: "preguntas",
                name: "preguntas",
                component: () => import("@/view/pages/admin/preguntas/PaginaAdminPreguntas.vue"),
                meta: { authorize: [6] },
              },

              {
                path: "boletas",
                name: "boletas",
                //component: () => import("@/view/pages/admin/boletas/PaginaAdminBoletas.vue")
                component: () => import("@/view/pages/admin/Dashboard.vue"),
                children: [
                  {
                    path: "registro",
                    name: "boletas-registro",
                    component: () => import("@/view/pages/admin/boletas/PaginaAdminBoletas.vue"),
                    meta: { authorize: [6] },
                  },
                  {
                    path: "configuracion",
                    name: "boletas-configuracion",
                    component: () => import("@/view/pages/admin/boletas/PaginaConfiguracionBoletas.vue"),
                    meta: { authorize: [6] },
                  },
                  {
                    path: "asignacion",
                    name: "boletas-asignacion-munis",
                    component: () => import("@/view/pages/admin/boletas/PaginaAsignacionBoletasMuni.vue"),
                    meta: { authorize: [6] },
                  },

                  {
                    path: "apertura-cierre",
                    name: "boletas-apertura-cierre-munis",
                    component: () => import("@/view/pages/admin/boletas/aperturacierre/PaginaAperturaCierreBoletas.vue"),
                    meta: { authorize: [6] },
                  },
                ]
              },

              {
                path: "calculo",
                name: "calculo",
                //component: () => import("@/view/pages/admin/boletas/PaginaAdminBoletas.vue")
                component: () => import("@/view/pages/admin/Dashboard.vue"),
                children: [
                  {
                    path: "diccionario",
                    name: "diccionario-respuestas",
                    component: () => import("@/view/pages/admin/calculo/PaginaDiccionarioRespuestas.vue"),
                    meta: { authorize: [6] },
                  },
                  {
                    path: "respuestas",
                    name: "exportar-respuestas",
                    component: () => import("@/view/pages/admin/calculo/PaginaListadoRespuestasMuni.vue"),
                    meta: { authorize: [6] },
                  },
                  {
                    path: "respuestas-test",
                    name: "exportar-respuestas-test",
                    component: () => import("@/view/pages/admin/calculo/PaginaListadoRespuestasMuniTest.vue"),
                    meta: { authorize: [6] },
                  },
                  {
                    path: "respuestas-aprobadas",
                    name: "exportar-respuestas-aprobadas",
                    component: () => import("@/view/pages/admin/calculo/PaginaListadoRespuestasMuniAprobadas.vue"),
                    meta: { authorize: [6] },
                  },
                  {
                    path: "respuestas-aprobadas-no-valida-revision",
                    name: "exportar-respuestas-aprobadas-f2",
                    component: () => import("@/view/pages/admin/calculo/PaginaListadoRespuestasMuniAprobadasF2.vue"),
                    meta: { authorize: [6] },
                  },
                  {
                    path: "respuestas-ingresadas",
                    name: "exportar-respuestas-ingresadas",
                    component: () => import("@/view/pages/admin/calculo/PaginaListadoRespuestasMuniIngresadas.vue"),
                    meta: { authorize: [6] },
                  },
                  {
                    path: "resumen-respuestas-ingresadas",
                    name: "resumen-respuestas-ingresadas",
                    component: () => import("@/view/pages/admin/calculo/PaginaResumenRespuestasMuniIngresadas.vue"),
                    meta: { authorize: [6] },
                  }

                ]
              },


              //!Rutas para la administracion de resutlados
              {
                path: "resultados",
                name: "admin-campos-resultados",
                component: () => import("@/view/pages/admin/Dashboard.vue"),
              
                children: [
                  {
                    path: "campos/registro",
                    name: "campos-resultados",
                    component: () => import("@/view/pages/admin/resultados/camposresultados/PaginaAdminCamposResultados.vue"),
                    meta: { authorize: [6] },
                    //meta: { authorize: [100] },
                  },
                  {
                    path: "campos/asignacion",
                    name: "asignacion-campos-resultados",
                    component: () => import("@/view/pages/admin/resultados/camposresultados/PaginaAsignacionCamposResultados.vue"),
                    meta: { authorize: [6] },
                    //meta: { authorize: [100] },
                  },
                  {
                    path: "campos/importacion",
                    name: "importacion-campos-resultados",
                    component: () => import("@/view/pages/admin/resultados/importacion/PaginaImportacionResultados.vue"),
                    meta: { authorize: [6] },
                    //meta: { authorize: [100] },
                  },

                  {
                    path: "reportes",
                    name: "reporte-resultados",
                    component: () => import("@/view/pages/admin/resultados/reportes/PaginaReportesResultados.vue"),
                    meta: { authorize: [6] },
                    //meta: { authorize: [100] },
                  },
                  
                ]
              },
             
              

          ]
        },
      ]
    },
   

    {
      path: "/custom-error",
      name: "error",
      component: () => import("@/view/pages/error/Error.vue"),
      children: [
        {
          path: "error-1",
          name: "error-1",
          component: () => import("@/view/pages/error/Error-1.vue")
        },
        {
          path: "error-2",
          name: "error-2",
          component: () => import("@/view/pages/error/Error-2.vue")
        },
        {
          path: "error-3",
          name: "error-3",
          component: () => import("@/view/pages/error/Error-3.vue")
        },
        {
          path: "error-4",
          name: "error-4",
          component: () => import("@/view/pages/error/Error-4.vue")
        },
        {
          path: "error-5",
          name: "error-5",
          component: () => import("@/view/pages/error/Error-5.vue")
        },
        {
          path: "error-6",
          name: "error-6",
          component: () => import("@/view/pages/error/Error-6.vue")
        }
      ]
    },
    {
      path: "/",
      component: () => import("@/view/pages/auth/login_pages/Login-1"),
      children: [

        {
          name: "mlogin",
          path: "/mlogin",
          component: () => import("@/view/pages/auth/login_pages/Login")
        },


        {
          name: "login",
          path: "/login",
          component: () => import("@/view/pages/auth/login_pages/Login-1")
        },
        {
          name: "register",
          path: "/register",
          component: () => import("@/view/pages/auth/login_pages/Login-1")
        }
      ]
    },
    {
      path: "*",
      redirect: "/404"
    },
    {
      // the 404 route, when none of the above matches
      path: "/404",
      name: "404",
      component: () => import("@/view/pages/error/Error-1.vue")
    },
    {
      // the 404 route, when none of the above matches
      path: "/unauthorized",
      name: "unauthorized",
      component: () => import("@/view/pages/error/Unauthorized.vue")
    }
    
  ]
  
  
})

router.beforeEach((to, from, next)=>{
 
  next();
})

export default router;
